import { SxProps, Theme } from '@mui/material';

type Styles = {
  scroll: (theme: Theme) => SxProps<Theme>;
  scrollWithBorder: (theme: Theme) => SxProps<Theme>;
  actionButton: SxProps<Theme>;
  columnFlexContainer: SxProps<Theme>;
  centerFlexContainer: SxProps<Theme>;
  textInformer: SxProps<Theme>;
};

export const commonStyles: Styles = {
  scroll: (theme: Theme) => ({
    padding: 0,
    overflowX: 'hidden',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: 0,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#bdbdbd',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#9e9e9e',
    },
  }),
  scrollWithBorder: (theme: Theme) => ({
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      borderLeft: `1px solid ${theme.palette.grey.additionalGrey}`,
    },
  }),
  actionButton: (theme: Theme) => ({
    background: 'tramsparent',
    padding: 0,
    color: theme.palette.grey[100],
    maxHeight: theme.spacing(3),
    border: `2px solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  }),
  columnFlexContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  centerFlexContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },

  textInformer: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    paddingBottom: 1,
  }),
};
